import { useMemo } from "react";

import { extractAndMergeOptions } from "./utils/extractAndMergeOptions";

export const TABLE_CONTROL_STATE_DEFAULTS = {
  pageSize: 10,
  density: "compact",
};
export function useTableControlStateDefaults(options) {
  return useMemo(
    () => extractAndMergeOptions(options, TABLE_CONTROL_STATE_DEFAULTS),
    [options],
  );
}
// sourceMappingURL=useTableControlStateDefaults.js.map
